import { all } from 'redux-saga/effects'

import { setEconomicsSaga } from '../../trade-approval/modules/02-set-economics/state/set-economics-slice'
import { initialiseSettlementSaga } from '../../trade-approval/modules/05-settlement/state/trade-settlement-slice'
import { builderRootSaga } from '../modules/00-builder/state/builder-slice'
import { existingNoteRootSaga } from '../modules/01-note/existing-note/existing-note-slice'
import { noteSearchSaga } from '../modules/01-note/existing-note/note-finder/note-search-slice'
import { newNoteRootSaga } from '../modules/01-note/new-note/new-note-slice'
import { noteStepRootSaga } from '../modules/01-note/note/note-step-slice'
import { termsRootSaga } from '../modules/02-terms/state/terms-slice'
import { portfolioStepRootSaga } from '../modules/03-portfolio/state/portfolio-slice'
import { strategyStepRootSaga } from '../modules/04-strategy/state/strategy-slice'
import { completeStepSaga } from '../modules/05-complete/complete-slice'

export function* rootSaga() {
  yield all([
    noteStepRootSaga(),
    newNoteRootSaga(),
    existingNoteRootSaga(),
    termsRootSaga(),
    builderRootSaga(),
    noteSearchSaga(),
    portfolioStepRootSaga(),
    strategyStepRootSaga(),
    completeStepSaga(),
    setEconomicsSaga(),
    initialiseSettlementSaga()
  ])
}
